import React, { memo } from 'react';
import { Text, View, StyleSheet } from 'react-native';
import { COLORS, FONTS, FONT_SIZES } from '@bcm/constants';

import GlobalPressable from './GlobalPressable';
import Icon from '../icon/Icon';
import { ICON_SIZE } from '../../../constants/UIConstants';

const IconButton = (props) => (
	<GlobalPressable
		style={styles.container}
		{...props}
	>
		<View style={styles.iconContainer}>
			<Icon
				icon={props.icon}
				size={(props.iconSize) ? props.iconSize
					: (props.hideText) ? ICON_SIZE.lg : ICON_SIZE.md}
				color={(props.color) ? props.color : COLORS.dark}
			/>
		</View>
		{!props.hideText && <View style={styles.textContainer}>
			<Text
				numberOfLines={1}
				style={{
					...styles.buttonText,
					color: (props.color) ? props.color : COLORS.dark
				}}
			>
				{(props.text) ? props.text : props.icon.text}
			</Text>
		</View>}
	</GlobalPressable>
);

const styles = StyleSheet.create({
	container: {
		width: 56,
		height: 56,
		marginHorizontal: 5,
	},
	iconContainer: {
		flex: 1,
		width: '100%',
		justifyContent: 'center',
		alignItems: 'center',
	},
	textContainer: {
		height: 20,
		justifyContent: 'center',
		alignItems: 'center',
	},
	buttonText: {
		textAlign: 'center',
		textAlignVertical: 'center',
		color: COLORS.dark,
		fontFamily: FONTS.default,
		fontSize: FONT_SIZES.xs,
	},
});

export default memo(IconButton);
